import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { parseQueryObject } from 'src/app/classes/shared/service.tools';
import { environment } from 'src/environments/environment';
import { QueryParams } from '../../interfaces/shared/query';

@Injectable({
  providedIn: 'root'
})

/**
 * Handle API Request to api.cad42.com
 */
export class ApiService {
  private apiUrl = environment.API_URL;

  constructor(
    private http: HttpClient,
  ) { }

  // Get server sync state
  getSyncState(dbName: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/sync/`);
  }

  // get operation on project collection
  getCollection(collectionPath: string, path: string = "", query: any = {}, options: { headers?: HttpHeaders } = {}): Observable<any> {
    let parseQuery: string = ""
    if (query)
      parseQuery = parseQueryObject(query);
    return this.http.get<any>(`${this.apiUrl}/${collectionPath}/${path}${parseQuery}`, options);
  }

  // get operation on project collection item
  getCollectionItem(collectionPath: string = "", path: string = "", id: string, options: { headers?: HttpHeaders } = {}): Observable<any> {
    if (path)
      path = path + '/';
    return this.http.get<any>(`${this.apiUrl}/${collectionPath}/${path}${id}`, options);
  }

  // post operation on project collection
  postCollectionData(collectionPath: string, path: string = "", data: any, options: any = {}): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}/${collectionPath}/${path}`, data, options);
  }

  // put operations on project collection
  updateCollection(collectionPath: string, path: string = "", data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${collectionPath}/${path}`, data);
  }

  // put operation on project collection
  updateCollectionItem(collectionPath: string, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${collectionPath}/${data.id}`, data);
  }

  // delete operation on project collection
  deleteCollectionItem(collectionPath: string, id?: string, query: any = {}): Observable<any> {
    let parseQuery: string = "";

    if (query)
      parseQuery = parseQueryObject(query);

    return this.http.delete<any>(`${this.apiUrl}/${collectionPath}${id ? `/${id}` : ''}${parseQuery}`);
  }

  // delete many operation on project collection
  deleteCollectionItems(collectionPath: string, query: QueryParams = {}): Observable<any> {
    const queryString = parseQueryObject(query);
    return this.http.delete<any>(`${this.apiUrl}/${collectionPath}/many${queryString}`);
  }

}
